import _ from 'underscore';

angular.module('am4')
.factory('imageService', function($http, $q, apiUrl) {
    return function imageTypeCurry(type) {
        return {
            getAll: function(id, image_type) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'media',
                    image_type
                ].join('/');
                return $http.get(url)
                .then(function(res) {
                    return _.sortBy(res.data, 'order');
                })
                .catch(function(res) {
                    if (res.status === 404) {
                        return res.data;
                    }

                    return $q.reject(res);
                });
            },
            getUploadPath: function(id, image_type) {
                return [
                    apiUrl,
                    type,
                    id,
                    'media',
                    image_type
                ].join('/');
            },
            getEquipmentGroupUploadPath: function(id, equipmentGroupId, image_type) {
                return [
                    apiUrl,
                    type,
                    id,
                    'group',
                    equipmentGroupId,
                    'media',
                    image_type
                ].join('/');
            },
            getImage: function(id, image_type) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'media',
                    image_type
                ].join('/');
                return $http.get(url)
                .then(function(res) {
                    return res.data;
                })
                .catch(function(res) {
                    if (res.status === 404) {
                        return res.data;
                    }

                    return $q.reject(res);
                });
            },
            postImage: function(id, image_type, imgFile) {
                var url = [
                        apiUrl,
                        type,
                        id,
                        'media',
                        image_type
                    ].join('/'),
                    formData = new FormData();

                formData.append('image', imgFile);

                return $http.post(url, formData, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }).then(function(res) {
                    return res.data;
                });
            },
            reorderImages: function(id, image_type, images) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'media',
                    image_type,
                    'order'
                ].join('/');

                return $http.put(url, { images: images })
                .then(function(res) {
                    return res.data;
                });
            },
            reorderEquipmentGroupImages: function(id, equipmentGroupId, image_type, images) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'group',
                    equipmentGroupId,
                    'media',
                    image_type,
                    'order'
                ].join('/');

                return $http.put(url, { images: images })
                .then(function(res) {
                    return res.data;
                });
            },
            deleteImage: function(id, image_type, image_id) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'media',
                    image_type,
                    image_id
                ].join('/');

                return $http.delete(url)
                .then(function(res) {
                    return res.data;
                });
            },
            deleteEquipmentGroupImage : function(id, equipmentGroupId, image_type, image_id) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'group',
                    equipmentGroupId,
                    'media',
                    image_type,
                    image_id
                ].join('/');

                return $http.delete(url)
                .then(function(res) {
                    return res.data;
                });
            },
            getEquipmentGroupImages : function(id, equipmentGroupId, image_type) {
                var url = [
                    apiUrl,
                    type,
                    id,
                    'group',
                    equipmentGroupId,
                    'media',
                    image_type
                ].join('/');
                return $http.get(url)
                .then(function(res) {
                    return _.sortBy(res.data, 'order');
                })
                .catch(function(res) {
                    if (res.status === 404) {
                        return res.data;
                    }

                    return $q.reject(res);
                });
            }
        };
    };
});



// WEBPACK FOOTER //
// ./src/app/services/image.js